export default "__VITE_ASSET__CZBtjYrG__"